import React from 'react';
import { getKeywordCluster } from '../utils/keywordClusters.js';
import './KeywordTopics.css';

function KeywordTopics({ slug }) {
  const keywords = getKeywordCluster(slug);
  if (keywords.length === 0) return null;

  return (
    <section className="keyword-topics" aria-label="Related topics">
      <div className="container keyword-topics-inner">
        <strong>Related topics</strong>
        <ul>{keywords.map((keyword) => <li key={keyword}>{keyword}</li>)}</ul>
      </div>
    </section>
  );
}

export default KeywordTopics;